import { formatLoanTermShort } from './getLoanTermOptions';
import { Tooltip } from 'devextreme-react/tooltip';

export const onLoanTermCellRender = (e) => {
    const originalTerm = formatLoanTermShort(
        e.data.loanTypeId,
        e.data.initialTermMonths,
        e.data.contractualExtension1Months,
        e.data.contractualExtension2Months
    );

    const targetId = `loanTerm_${e.data.id}`;
    return (
        <>
            <div
                data-tip
                data-for={targetId}
            >
                {originalTerm}
            </div>
            <Tooltip
                target={`[data-for="${targetId}"]`}
                showEvent='mouseenter'
                hideEvent='mouseleave'
                hideOnOutsideClick={false}
            >
                Original Term
            </Tooltip>
        </>
    );
};
